<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     布局模板 MenuSection 组件
  | @Version:   2018-11-27  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div v-if="section.meta.show === 1">
    <template v-if="!section.children">
      <menu-section-link :to="section.path" :meta="section.meta">
        <el-menu-item :index="section.name">
          {{ section.meta.title }}
        </el-menu-item>
      </menu-section-link>
    </template>
  </div>
</template>

<script>
import MenuSectionLink from './MenuSectionLink'
export default {
  name: 'MenuSection',
  components: {
    MenuSectionLink
  },
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">

</style>
